exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MY9aRT5wgoL5oJerATFxb{width:20px!important;height:23px!important}html[dir] .MY9aRT5wgoL5oJerATFxb{background-size:28px 19px;background-repeat:no-repeat;background-position:1px 1px!important}._2Zsx8gQGYNxf0smazhLgTZ{fill:var(--neutralPrimary);width:19px!important;height:22px!important}", ""]);
// Exports
exports.locals = {
	"teamSnapIconSpriteStyle": "MY9aRT5wgoL5oJerATFxb",
	"teamSnapIcon": "_2Zsx8gQGYNxf0smazhLgTZ"
};